import { query, request } from '@/utils/request';
import { stringify } from 'qs';

const prefix = '';

export const reqdDiscardFormDefine = data => {
  return request('/zlb/api/mbp/baida/form-define/discard', {
    method: 'POST',
    data,
  });
};

// 拉取机构预算信息
export function pullBudgetIndicator(orgId) {
  return request(`/zlb/budget/operation/platform/pull-budget-info/${orgId}`);
}

// 根据机构id查询机构
export function getBudgetOrgByOrgId(orgId) {
  return request(`/zlb/budget/operation/platform/query-budget-org-org-id/${orgId}`);
}

// 修改预算单位映射信息
export function updateBudgetOrgMapping(params) {
  return request('/zlb/budget/operation/platform/update-budget-org', {
    method: 'post',
    data: params,
  });
}

// 拉取预算单位
export function pullBudgetOrgAction(params) {
  return request('/zlb/budget/operation/platform/pull-budget-org', {
    method: 'post',
    data: params,
  });
}

// 获取预算单位信息
export function getBudgetOrgInfoServer(params) {
  return request('/zlb/budget/operation/platform/query-budget-org', {
    method: 'post',
    data: params,
  });
}

// 获取预算单位信息
export function searchHistoryRecord(params) {
  return request('/zlb/budget/operation/platform/query-org-match-log', {
    method: 'post',
    data: params,
  });
}

// 下载
export function downloadOrgInfo(params) {
  return request('/zlb/budget/operation/platform/download', {
    method: 'post',
    data: params,
    responseType: 'blob',
  });
}

// 枚举：预算关联状态
export function getBudgetAssociationStatus(params) {
  return request('/api/user/enum/listCostControlStatusEnum', {
    params,
  });
}

// 枚举：预算匹配状态
export function getBudgetMatchStatus(params) {
  return request('/api/user/enum/listBudgetMatchStatusEnum', {
    params,
  });
}

// 枚举：一致性状态
export function getConsistencyState(params) {
  return request('/api/user/enum/listConsistencyCheckEnum', {
    params,
  });
}

// 批量导出单位
export function bulkExportUnit(params) {
  return request('/api/zlbuser/institution/downCheckResults', {
    responseType: 'blob',
    method: 'post',
    data: params,
  });
}

// 查询机构映射信息
export function queryBudgetOrgMapping(params) {
  return request('/zlb/budget/operation/platform/query-budget-org-detail', {
    method: 'post',
    data: params,
  });
}

// 查询未映射的预算单位信息
export function queryNotMappingBudgetOrgPage(params) {
  return request('/zlb/budget/operation/platform/query-budget-org-page', {
    method: 'post',
    data: params,
  });
}

/**
 *
 * 单位管理
 * @param {*} params
 * @returns
 *
 */

// 获取机构树接口
export function getInstitutionTree(params) {
  return request('/api/zlbuser/institution/operational/institution/tree', {
    params,
  });
}

// 分页查询机构下级单位列表
export function getInstitutionList(params) {
  return request(`/api/zlbuser/institution/operational/institution/list?${stringify(params)}`);
}

// 获取指定机构下的单位管理员列表人员姓名精准搜索
export function getInstitutionOperator(params) {
  return request('/api/zlbuser/operational/institution/operator', {
    params,
  });
}

export function updateInstitutionStatus(params) {
  return request('/api/zlbuser/institution/operational/institution/status', {
    method: 'POST',
    data: params,
  });
}

export function updateFundPayStatus(params) {
  return request('/zlb/api/pay/config/batchEdit', {
    method: 'POST',
    data: params,
  });
}

export function getImportManagerTemplate(params = {}) {
  return request('/api/user/operational/importManager/template', {
    params,
  });
}

export function importUpload(data) {
  return request('/api/user/import/upload', {
    method: 'POST',
    headers: {
      'Content-type': 'application/x-www-form-urlencoded;charset=utf-8',
    },
    data,
  });
}

export function updateOperational(params) {
  return request('/api/zlbuser/institution/operational/institution/update', {
    method: 'POST',
    data: params,
  });
}

export function importManagerRecord(params) {
  return request('/api/user/operational/importManager/record', {
    responseType: 'blob',
    params,
  });
}

export function updateOperationalStatus(params) {
  return request('/api/zlbuser/operational/institution/manager', {
    method: params.method || 'post',
    data: params,
  });
}

/**
 * 获取人员列表模版链接
 */
export async function getImportUnitTemplate(params) {
  return request(`/api/user/import/template?${stringify(params)}`);
}

// 下载失败记录文件
export async function downloadFailFile(params) {
  return request('/api/zlbuser/institution/import/record', {
    responseType: 'blob',
    params,
  });
}

// 预算指标列表（分页）
export function fetchBudgetList(data) {
  return request('/zlb/budget/operation/platform/budget-info-page', {
    method: 'POST',
    data,
  });
}

// 预算指标与报销场景关联
export function budgetReimburseRelation(data) {
  return request('/zlb/budget/operation/platform/budget-scenes-relation', {
    method: 'POST',
    data,
  });
}

// 根据预算id查询预算报销场景
export function queryBudgetSceneByBudgetId(id) {
  return request(`/zlb/budget/operation/platform/query-budget-scenes-budget-id/${id}`);
}

/**
 * 流程分页列表&流程类型名称模糊搜索
 */
export async function pageProcess(params) {
  return request('/workflow/baseInfo/pageProcess', {
    method: 'get',
    params,
  });
}

/**
 * 新增流程
 */
export async function newProcessModel(data) {
  return request('/workflow/processModel/newProcessModel', {
    method: 'post',
    data,
  });
}

/**
 * 复制流程
 */
export async function copyProcessModel(data) {
  return request('/workflow/processModel/copyProcessModel', {
    method: 'post',
    data,
  });
}

/**
 * 流程分页列表接口
 */
export async function pageProcessModel(data) {
  return request('/workflow/processModel/pageProcessModel', {
    method: 'post',
    data,
  });
}

/**
 * 校验空流程
 */
export async function checkEmptyProcess(params) {
  return request('/workflow/processModel/checkEmptyProcess', {
    method: 'get',
    params,
  });
}

/**
 * 上下架流程
 */
export async function changeStatus(data) {
  return request('/workflow/processModel/changeStatus', {
    method: 'post',
    data,
  });
}

/**
 * 分页获取机构或者部门下操作人员列表(非脱敏)
 *
 * @param institutionId
 * @param departmentId
 * @param pageSize
 * @param pageNo
 * @return
 */
export async function getInstitutionMember(params) {
  return request('/zlb/operation/organization/operatorInfo/list', {
    params,
  });
}

/**
 * 分页获取机构或者部门下操作人员列表(脱敏)
 *
 * @param institutionId
 * @param departmentId
 * @param pageSize
 * @param pageNo
 * @return
 */
export async function getInstitutionMemberDesensitization(params) {
  return request('/zlb/operation/organization/operator/list', {
    params,
  });
}

/**
 * 新增人员
 */
export async function addUser(data) {
  return request('/zlb/operation/createUser', {
    method: 'post',
    data,
  });
}

/**
 * 人员信息信息更新
 */
export async function updateUser(data) {
  return request('/zlb/operation/updateOperator', {
    method: 'post',
    data,
  });
}

/**
 * 查询操作人更多信息
 *
 * @param departmentId 操作人部门id
 * @param operatorId   操作人id
 * @return
 */
export async function getUserDetail(params) {
  return request('/zlb/operation/getUserDetail', {
    params,
  });
}

/**
 * 查询操作人更多信息(非脱敏)
 *
 * @param departmentId 操作人部门id
 * @param operatorId   操作人id
 * @return
 */
export async function getUserDetailInfo(params) {
  return request('/zlb/operation/getUserDetailInfo', {
    params,
  });
}

/**
 * 单位管理删除操作员身份
 */
export async function deleteOperatorAppointment(data) {
  return request('/zlb/operation/deleteOperator', {
    data,
    method: 'delete',
  });
}

/**
 * 单位管理批量删除操作员身份
 */
export async function batchDeleteOperator(data) {
  return request('/zlb/operation/batchDeleteOperator', {
    data,
    method: 'delete',
  });
}

/**
 * 查询操作员在机构部门下的所有任职
 * @param {*} params
 * @returns
 */
export async function queryAppointment(params) {
  return request('/zlb/operation/queryAppointment', {
    params,
  });
}

/**
 * 批量启用或停用用户接口
 */
export async function batchUpdateOperatorStatus(data) {
  return request('/zlb/operation/batchUpdateOperatorStatus', {
    data,
    method: 'post',
  });
}

/**
 * 单位管理批量调整部门接口
 */
export async function batchUpdateOperatorDept(data) {
  return request('/zlb/operation/batchUpdateOperatorDept', {
    data,
    method: 'post',
  });
}

/**
 * 单位管理获取用户所在机构下的部门树
 * @param {*} params
 * @returns
 */
export async function getTree(params) {
  return request('/zlb/operation/department/tree', {
    params,
  });
}

/**
 * 获取职级枚举集合
 * @returns
 */
export async function getOperatorRank() {
  return request(`${prefix}/api/user/dictionary/operator/rank`);
}

/**
 * 获取政治面貌枚举集合
 * @returns
 */
export async function getPoliticsstatus() {
  return request(`${prefix}/api/user/dictionary/politicsstatus`);
}

/**
 * 获取人员任职枚举集合
 * @returns
 */
export async function getPersonnelOffice() {
  return request(`${prefix}/api/user/dictionary/personnel/office`);
}

/**
 * 获取人员编制集合
 * @returns
 */
export async function getPersonnelForce() {
  return request(`${prefix}/api/user/dictionary/personnel/force`);
}

/*
 * 费控规则
 */
export async function queryCostControlRule(params) {
  return request(`/zlb/cost/control/standard/get-by-district/${params}`, {
    method: 'get',
  });
}

/*
 * 费控规则
 */
export async function queryCostControlRuleByOrgId(params) {
  return request(`/zlb/cost/control/standard/get-by-org-id/${params}`, {
    method: 'get',
  });
}

/**
 * 获取人员列表模版链接
 */
export async function getImportUserTemplate(params) {
  return request(`/api/user/import/template?${stringify(params)}`);
}

/**
 * 上传人员列表Excel
 */
export async function importUploadUser(data) {
  return request('/api/user/import/upload', {
    method: 'post',
    data,
  });
}

/**
 * 下载失败文件
 */
export async function importUserRecord(params) {
  return request('/api/user/import/user/record', {
    responseType: 'blob',
    params,
  });
}

// 标签类型和标签列表查询
export async function getTypeAndTagList(params) {
  return query('/api/zlbuser/tag/typeAndTagList', { params });
}

// 标签分类查询
export async function getTagTypeList(params) {
  return query('/api/zlbuser/tagtype/list', { params });
}

// 标签查询
export async function getTagList(params) {
  return query('/api/zlbuser/tag/list', { params });
}

// 划配置标签
export async function removeDomainTag(data) {
  return request('/api/zlbuser/tag/removeBillTag', {
    data,
    method: 'post',
  });
}

// 单位批量新增标签
export async function addDomainTag(data) {
  return request('/api/zlbuser/tag/addBillTag', {
    data,
    method: 'post',
  });
}
// 删除预算单位匹配关系
export function cancelOrgMatch(data) {
  return request('/zlb/budget/operation/platform/cancel-match', {
    data,
    method: 'POST',
  });
}

// 标签联合查询
export function getTagCombineList(params) {
  return request('/api/zlbuser/tag/tagCombineList', {
    params,
  });
}

// 批量导入人员操作-提交
export function importExcelCommit(data) {
  return request('/api/user/import/excel/commit', {
    data,
    method: 'POST',
  });
}

// 批量导入人员操作-查询
export function importExcelResult(serialCode) {
  return request(`/api/user/import/excel/result?serialCode=${serialCode}`);
}

export function institutionInfoModify(data) {
  return query('/zlb/operation/institution/info/modify', {
    data,
    method: 'POST',
  });
}
export function deleteInstitution(data) {
  return query('/api/zlbuser/institution/delete', {
    method: 'POST',
    data,
  });
}

// 一键检测
export function institutionCheckHandler(data) {
  return request('/zlb/operation/ins/check/institutionCheck', {
    data,
    method: 'POST',
  });
}

// 一键检测结果查询
export function listInsCheckRecord(data) {
  return request('/zlb/operation/ins/check/listInsCheckRecord', {
    data,
    method: 'POST',
  });
}

// 一键检测删除
export function delInsCheckRecord(params) {
  return request('/zlb/operation/ins/check/delInsCheckRecord', {
    params,
  });
}

// 一键检测结果下载
export function insCheckResult(params) {
  return request('/zlb/operation/ins/check/download/insCheckResult', {
    params,
  });
}

/**
 * 获取机构的异常信息
 * @param {} data
 * @returns
 */
export function getInstitutionExceptionData(data) {
  return request('/zlb/operation/exception/record/num', {
    data,
    method: 'POST',
  });
}

// 表单和流程配置页面初始化接口
export function reqFormProcessInit(params) {
  return request('/zlb/api/mbp/baida/config/info', {
    params,
  });
}

// 获取单据
export const reqDocumentDetailData = formDefineCode => {
  return request(`/zlb/api/mbp/baida/form-define/info/${formDefineCode}`, {
    method: 'get',
  });
};

// 获取单据快照
export const reqDocumentData = formDefineCode => {
  return request(`/zlb/api/mbp/baida/form-define/info/${formDefineCode}`, {
    method: 'get',
  });
};

/**
 * 更新单据信息
 * @param {} data
 * @returns
 */
export function reqUpdateDocumentData(data) {
  return request('/zlb/api/mbp/baida/form-define/update-by-org', {
    data,
    method: 'POST',
  });
}

/**
 * 更新单据信息
 * @param {} data
 * @returns
 */
export function reqPublishDocumentData(data) {
  return request('/zlb/api/mbp/baida/form-define/publish', {
    data,
    method: 'POST',
  });
}

/**
 * 更新表单信息
 * @param {} data
 * @returns
 */
export function reqUpdateFormData(data) {
  return request('/zlb/api/mbp/baida/form/update', {
    data,
    method: 'POST',
  });
}

/* 单位测查询发布单据  http://yapi.cai-inc.com/project/3096/interface/api/cat_50330 */
export const reqGetFormListByOrg = data => {
  // return request('/zlb/api/mbp/baida/form-define/paging', {
  //   method: 'POST',
  //   data,
  // });
  return request('/zlb/api/mbp/baida/form-define/list-for-org', {
    method: 'POST',
    data,
  });
};

/**
 * 流程详情
 */
export async function getProcessModel(params) {
  return request('/workflow/processModel/getProcessModel', {
    method: 'get',
    params,
  });
}

// 用户手机号修改接口
export function updateUserMobile(data) {
  return request('/zlb/operation/user/mobile/modify', {
    data,
    method: 'POST',
  });
}

// 用户外部关联Id修改接口
export function updateUserAccount(data) {
  return request('/zlb/operation/user/account/modify', {
    data,
    method: 'POST',
  });
}

// 机构外部组织关联取消
export function cancelOuterOrgBind(data) {
  return query('/api/zlbuser/institution/outer/org/cancel/bind', {
    data,
    method: 'POST',
  });
}

/**
 * 获取机构关联外部节点信息
 * @param params
 * @returns
 */
export function getOuterBindOrgInfo(params) {
  return query('/api/zlbuser/institution/outer/org/bind/info', {
    params,
  });
}

/**
 * 获取外部数据源下级组织
 * @param params
 * @returns
 */
export function getOuterOrgSubordinate(params) {
  return query('/api/zlbuser/institution/outer/org/subordinate', {
    params,
  });
}

/**
 * 获取外部数据源组织路径
 * @param params
 * @returns
 */
export function getOuterOrgRoute(params) {
  return query(`/api/zlbuser/institution/outer/org/route?${stringify(params)}`);
}

/**
 * 机构关联外部数据源
 * @param data
 * @returns
 */
export function bindOuterOrg(data) {
  return request('/api/zlbuser/institution/outer/org/bind', {
    data,
    method: 'POST',
  });
}

/**
 * 机构更换外部数据源
 * @param data
 * @returns
 */
export function updateBindOuterOrg(data) {
  return request('/api/zlbuser/institution/outer/org/update/bind', {
    data,
    method: 'POST',
  });
}

export function updateBaidaPrintConfig(data) {
  return request('/zlb/api/mbp/baida/print/update-config', {
    data,
    method: 'POST',
  });
}

// 查询查询已关联的预算 百搭
export function queryOrgBudgetWithRelation(data) {
  return request('/zlb/budget/info/query-org-budget-with-relation', {
    data,
    method: 'POST',
  });
}

// 查询查询未关联的预算 百搭
export function queryOrgBudgetWithoutRelation(data) {
  return request('/zlb/budget/info/query-org-budget-without-relation', {
    data,
    method: 'POST',
  });
}
export const getBaidaPrintConfig = async params => {
  return query('/zlb/api/mbp/baida/print/get-config', {
    params,
  });
};

export function cancelBudgetWithscene(data) {
  return request('/zlb/budget/scenes/rel/cancel', {
    data,
    method: 'POST',
  });
}

// 绑定预算 /zlb/budget/scene/rel/save
export function saveBudgetWithscene(data) {
  return request('/zlb/budget/scenes/rel/save', {
    data,
    method: 'POST',
  });
}

// 获取单位下不同差旅类型的业务规则
export function getBusinessRule(data) {
  return request('/zlb/api/expense/config/business/rule/init', {
    data,
    method: 'POST',
  });
}

// 配置项修改接口
export function editBusinessRule(data) {
  return request('/zlb/api/expense/config/business/rule/edit', {
    data,
    method: 'POST',
  });
}
// 设置原子token
export const getAtomToken = () => {
  return query('/zlb/api/mbp/baida/form/atom/get-token');
};

// 设置主数据源
export const bindMainData = data => {
  return query('/api/zlbuser/institution/outer/org/mainData/bind', {
    method: 'POST',
    data,
  });
};

// 设置常驻地
export const configCommonPlace = data => {
  return query('/api/zlbuser/operation/location', {
    method: 'POST',
    data,
  });
};

// 获取常驻地
export const getCommonPlace = params => {
  return query('/api/zlbuser/operation/location', {
    params,
  });
};

// 获取机构关联租户业务信息
export const getZlbUserTenantInstitutionBusiness = params => {
  return query('/api/zlbuser/tenant/institution/business', {
    params,
  });
};

// 更新机构关联租户业务信息
export const saveZlbUserTenantInstitutionBusiness = data => {
  return query('/api/zlbuser/tenant/institution/business', {
    data,
    method: 'POST',
  });
};

// 获取预算模版链接
export async function getImportBudgetTemplate(params) {
  return request('/zlb/budget/import/get-template', {
    params,
  });
}

// 导入预算任务提交
export async function submitImportBudget(data) {
  return query('/zlb/budget/import/submit', {
    data,
    method: 'POST',
  });
}

// 获取预算导入结果
export function getBudgetImportResult(data) {
  return query('/zlb/budget/import/result', {
    data,
    method: 'POST',
  });
}

// 保存导入数据
export function saveBudgetImportData(data) {
  return query('/zlb/budget/import/save', {
    data,
    method: 'POST',
  });
}
// [获取租户以及单位的关联(前端进行分页) 参考运营管理- 费用标准↗]
export function zlbApiExpenseDeclarationTransferConfigGetRelationListGet(params) {
  return query(
    `/zlb/api/expense/declaration/transfer/config/get-relation/list?${stringify(params)}`,
  );
}

// [更新租户或单位关联关系(可能新增, 可能删除已有)↗]
export function zlbApiExpenseDeclarationTransferConfigUpdateBindPost(data) {
  return query('/zlb/api/expense/declaration/transfer/config/update-bind', {
    method: 'POST',
    data,
  });
}
// 校验工作流是否为百搭
export async function checkWorkflowIsBaida(data) {
  return request('/zlb/api/mbp/workflow/used-baida-check', {
    method: 'post',
    data,
  });
}

// 运营侧部门树
export function getOperationInstitutionTree(params) {
  return query('/api/zlbuser/institution/operation/department/tree', {
    params,
  });
}

// 查询附件配置 /zlb/api/expense/attachment/config/query
export function queryAttachmentConfig(data) {
  return query('/zlb/api/expense/attachment/config/query', {
    method: 'POST',
    data,
  });
}
// 保存附件配置 /zlb/api/expense/attachment/config/save
export function saveAttachmentConfig(data) {
  return query('/zlb/api/expense/attachment/config/save', {
    data,
    method: 'POST',
  });
}
// 删除附件配置 /zlb/api/expense/attachment/config/delete
export function deleteAttachmentConfig(data) {
  return query('/zlb/api/expense/attachment/config/delete', {
    data,
    method: 'POST',
  });
}
// ======金控企业logo业务配置=====
// 上传logo
export function addBusinessLogo(data) {
  return query('/api/zlbuser/operation/save/business/setting', {
    data,
    method: 'POST',
  });
}
export function deleteBusinessLogo(data) {
  return query('/api/zlbuser/operation/delete/business/setting', {
    data,
    method: 'POST',
  });
}
export function queryBusinessLogo(params) {
  return query('/api/zlbuser/institution/setting', {
    params,
  });
}

// 更新配置信息
export function updateBusinessInfo(data) {
  return query('/api/zlbuser/operation/update/business/setting', {
    method: 'POST',
    data,
  });
}

// 获取单位核算归档配置详情
export function getAccountingConfigDetail(params) {
  return query('/zlb/api/archive/accounting/institution/detail', { params });
}

// 保存单位核算归档配置
export function saveAccountingConfig(data) {
  return query('/zlb/api/archive/accounting/institution/save-or-update', {
    data,
    method: 'POST',
  });
}

/**
 * 获取母版列表
 */
export async function getMasterList(data) {
  return request('/workflow/processModel/getMasterList', {
    method: 'post',
    data,
  });
}

/**
 * 流程筛选状态列表
 */
export async function listStatus(params) {
  return request('/workflow/processModel/listStatus', {
    method: 'get',
    params,
  });
}

/**
 * 删除流程
 */
export async function deleteProcessModel(data) {
  return request('/workflow/processModel/deleteProcessModel', {
    method: 'post',
    data,
  });
}

// ------------------ 预算项目控制 ---------------------
// 预算项目控制列表
export async function getProjectControlList(data) {
  return query('/zlb/budget/ep/project/control/page', {
    method: 'post',
    data,
  });
}

/**
 * 运营后台单位管理编辑采购管理场景信息 单条
 */
export async function editPurchasingSceneConfig(data) {
  return request('/zlb/api/expense/config/platform/edit-scene-config', {
    method: 'post',
    data,
  });
}
//  运营后台单位管理编辑采购管理场景信息 多条
export async function editPurchasingSceneConfigList(data) {
  return request('/zlb/api/expense/config/platform/batch/edit-scene-config', {
    method: 'post',
    data,
  });
}

// 预算项目控制更新
export async function updateProjectControl(data) {
  return query('/zlb/budget/ep/project/control/update', {
    method: 'post',
    data,
  });
}

/**
 * 运营后台单位管理查询特定场景信息
 */
export async function getSceneConfigList(data) {
  return request('/zlb/api/expense/config/platform/scene-config-list', {
    method: 'post',
    data,
  });
}

/**
 * 获取百搭字段映射配置
 */
export async function getBaidaFieldMapConfig(data) {
  return request('/zlb/api/mbp/baida/field/mapping/config/getInfo', {
    method: 'post',
    data,
  });
}
/**
 * 保存百搭字段映射配置
 */
export async function saveBaidaFieldMapConfig(data) {
  return request('/zlb/api/mbp/baida/field/mapping/config/saveUpdate', {
    method: 'post',
    data,
  });
}
/**
 * 保存百搭导出配置
 */
export async function saveBaidaExportConfig(data) {
  return request('/zlb/api/mbp/baida/export/config/save-or-update', {
    method: 'post',
    data,
  });
}
/**
 * 获取百搭导出配置
 */
export async function getBaidaExportConfigInfo(data) {
  return request('/zlb/api/mbp/baida/export/config/list-by-form-define-code', {
    method: 'post',
    data,
  });
}
// ------------------ 预算设置管理 ---------------------
// 查询预算项目的使用范围
export async function queryBudgetUsePage(data) {
  return query('/zlb/budget/ep/project-use/project-use/page', {
    method: 'post',
    data,
  });
}

// 查询银行支行配置
export async function queryBankBranchConfig(data) {
  return query('/zlb/api/pay/config/query-bank-branch-config', {
    method: 'post',
    data,
  });
}

//保存银行支行配置
export async function saveBankBranchConfig(data) {
  return query('/zlb/api/pay/config/save-bank-branch-config', {
    method: 'post',
    data,
  });
}

//查询企业关帐配置
export async function queryOrgCloseAccountConfig(params) {
  return request('/zlb/api/pay/config/query-org-close-account-config', {
    method: 'get',
    params,
  });
}

//保存企业关帐配置
export async function SaveOrgCloseAccountConfig(data) {
  return query('/zlb/api/pay/config/batchEdit', {
    method: 'post',
    data,
  });
}
